class ratesRegister {

    static rates = null;
    static base = null;

    static setRates(data){
        try {
            sessionStorage.setItem('rates', JSON.stringify(data));
        }catch (e) {
            ratesRegister.rates = data;
        }
    }

    static getRates(data){
        try {
            if(ratesRegister.base.toLowerCase() === data.toLowerCase()){
                if(ratesRegister.rates){
                    return ratesRegister.rates;
                }else{
                    if(ratesRegister.rates){
                        return ratesRegister.rates;
                    }else if(JSON.parse(sessionStorage.getItem('rates'))){
                        return JSON.parse(sessionStorage.getItem('rates'));
                    }else{
                        return null;
                    }
                }
            }else{
                return null;
            }
        }catch (e) {
            return null;
        }
    }

    static removeRates(){
        ratesRegister.rates = null;
        try {
            sessionStorage.removeItem('rates');
        }catch (e) {}
    }

    //SHORTENER
    static set(rates){
        ratesRegister.setRates(rates);
    }

    static get(base){
        return ratesRegister.getRates();
    }

    static remove(){
        ratesRegister.removeRates();
    }

}

export {ratesRegister}


// WEBPACK FOOTER //
// ./src/services/ratesRegister.js